import ProductListWrapper from './ProductListWrapper'

export default ProductListWrapper
